import { useLocation } from "react-router-dom";
import styles from "./CleanerHome.module.css";
import { Col, List, Row } from "antd";
import { BsCheckCircle, BsFillCheckCircleFill } from "react-icons/bs";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import moment from "moment";
import { GoPrimitiveDot } from "react-icons/go";
import { useDispatch } from "react-redux";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import CleanerMiddleware from "../../store/Middlewares/CleanerMiddleware";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";


const CleanerHome = () => {

  const dispatch = useDispatch();
  const [CleanerDashboard, setCleanerDashboard] = useState();
  const [JobsList, setJobsList] = useState([]);
  const { t, i18n } = useTranslation();

  useEffect(() => {
    getCategories()
    getCleanerDashboard();
    getLanguage();
  }, []);

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories())
  }

  const getCleanerDashboard = () => {
    dispatch(AuthMiddleware.getUserInfo())
    dispatch(CleanerMiddleware.getCleanerDashboard()).then(data => {
      setCleanerDashboard(data?.data);
      setJobsList(data?.data?.jobs);
    });
  };

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  
  const renderItem = (item) => {
    return (
      <div className={styles.listItem}>
        <div className={styles.listHeader}>
          {item?.status == "working" ? <h2>Active Job</h2> : <h2>Next Job</h2>}
          <div className={styles.type}>
            <GoPrimitiveDot
              color={item?.status == "working" ? "#00DE25" : "#707070"}
              size={35}
            />
            <h4>{item?.status}</h4>
          </div>
        </div>
        <div className={styles.content}>
          <div className={styles.row1}>
            <div className={styles.col1}>
              <span>Task Location</span>
              <p>{item?.location?.address}</p>
            </div>
            <div className={styles.col1}>
              <span>Time</span>
              <p>{moment('01 jan 1947 ' + item?.start_time).format('hh:mm A')}</p>
            </div>
          </div>
          <div>
            <span>Date</span>
            <p>{item?.date
              ? moment(item?.date).format('MM-DD-YYYY')
              : ''}</p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={styles.ChecklistReport_mainCon}>
      {/* <div className={styles.ChecklistReport_heading}>
        <h1>{t("Checklist Report")}</h1>
      </div> */}
      <Row className={styles.ChecklistReport_row}>
        <Col className={styles.ChecklistReport_colLeft}>
          <div className={styles.ChecklistReport_colLeftOne}>
            <span className={styles.ChecklistReport_num}>{CleanerDashboard?.total}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Total Jobs")}</p>
          </div>
          <div className={styles.ChecklistReport_colLeftTwo}>
            <span className={styles.ChecklistReport_num}>{CleanerDashboard?.completed}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Completed Jobs")}</p>
          </div>
          <div className={styles.ChecklistReport_colLeftThree}>
            <span className={styles.ChecklistReport_num}>{CleanerDashboard?.pending}</span>
            <p className={styles.ChecklistReport_jobs}>{t("Pending Jobs")}</p>
          </div>
        </Col>
        <Col className={styles.ChecklistReport_colRight}>
          <List
            style={{ width: "100%" }}
            //   grid={{ xs: 1, sm: 1, md: 2, lg: 2, xl: 2, xxl: 2 }}
            dataSource={JobsList?.length > 0 ? JobsList : []}
            //   footer={loadMore}
            renderItem={renderItem}
          />
        </Col>
      </Row>
    </div>
  );
};
export default CleanerHome;
